/** Largest PDF / Word file the Image library's Documents tab accepts (t1389). */
export const MAX_LIBRARY_DOCUMENT_BYTES = 20 * 1024 * 1024;
export const LIBRARY_DOCUMENT_TYPES = {
    'application/pdf': 'PDF',
    'application/msword': 'Word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word',
};
export const LIBRARY_DOCUMENT_EXTENSIONS = ['.pdf', '.doc', '.docx'];
/** Value for an `<input type="file" accept>`. */
export const LIBRARY_DOCUMENT_ACCEPT = [
    ...LIBRARY_DOCUMENT_EXTENSIONS,
    ...Object.keys(LIBRARY_DOCUMENT_TYPES),
].join(',');
//# sourceMappingURL=documents.js.map